import { render } from "./TruckForm.vue?vue&type=template&id=b091f7cc"
import script from "./TruckForm.vue?vue&type=script&lang=js"
export * from "./TruckForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__